import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

export default function AllProducts() {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // 🔍 Filters
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState("latest");
  const [category, setCategory] = useState("");
  const [minPrice, setMinPrice] = useState("");
  const [maxPrice, setMaxPrice] = useState("");
  const [inStock, setInStock] = useState(false);

  // 🔹 Fetch products and categories
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await axios.get("https://cartbackend.wsdstech.com/api/products");
        setProducts(res.data.data || res.data);
      } catch (err) {
        setError("Failed to fetch products");
      } finally {
        setLoading(false);
      }
    };

    const fetchCategories = async () => {
      try {
        const res = await axios.get("https://cartbackend.wsdstech.com/api/categories");
        setCategories(res.data.data || res.data);
      } catch (err) {
        console.error("Failed to fetch categories");
      }
    };

    fetchProducts();
    fetchCategories();
  }, []);

  // 🔎 Apply filters
  const filteredProducts = products
    .filter((p) => p.name.toLowerCase().includes(search.toLowerCase()))
    .filter((p) => (category ? p.category_id === parseInt(category) : true))
    .filter((p) => (minPrice ? p.price >= parseFloat(minPrice) : true))
    .filter((p) => (maxPrice ? p.price <= parseFloat(maxPrice) : true))
    .filter((p) => (inStock ? p.stock > 0 : true))
    .sort((a, b) => {
      if (sort === "price_low_high") return a.price - b.price;
      if (sort === "price_high_low") return b.price - a.price;
      return b.id - a.id; // latest first
    });

  return (
    <div className="container-fluid my-5">
      <div className="row">
        {/* 🔹 Sidebar Filters */}
        <div className="col-md-3 mb-4">
          <div className="p-3 border rounded shadow-sm bg-light">
            <h5 className="mb-3">Filters</h5>

            <div className="form-group">
              <input
                type="text"
                placeholder="Search..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="form-control"
              />
            </div>

            <div className="form-group">
              <label>Sort By</label>
              <select
                value={sort}
                onChange={(e) => setSort(e.target.value)}
                className="form-control"
              >
                <option value="latest">Latest</option>
                <option value="price_low_high">Price: Low to High</option>
                <option value="price_high_low">Price: High to Low</option>
              </select>
            </div>

            <div className="form-group">
              <label>Category</label>
              <select
                value={category}
                onChange={(e) => setCategory(e.target.value)}
                className="form-control"
              >
                <option value="">All Categories</option>
                {categories.map((cat) => (!cat.parent_id && (
                  <option key={cat.id} value={cat.id}>
                    {cat.name}
                  </option>
                )))}
              </select>
            </div>

            <div className="form-group">
              <label>Min Price</label>
              <input
                type="number"
                placeholder="Min Price"
                value={minPrice}
                min={0}
                onChange={(e) => setMinPrice(e.target.value)}
                className="form-control"
              />
            </div>

            <div className="form-group">
              <label>Max Price</label>
              <input
                type="number"
                placeholder="Max Price"
                value={maxPrice}
                min={0}
                onChange={(e) => setMaxPrice(e.target.value)}
                className="form-control"
              />
            </div>

            <div className="form-check">
              <input
                type="checkbox"
                checked={inStock}
                onChange={(e) => setInStock(e.target.checked)}
                className="form-check-input"
                id="inStock"
              />
              <label className="form-check-label" htmlFor="inStock">
                In Stock Only
              </label>
            </div>
          </div>
        </div>

        {/* 🔹 Products Grid */}
        <div className="col-md-9">
          {loading ? (
            <p>Loading products...</p>
          ) : error ? (
            <p className="text-danger">{error}</p>
          ) : filteredProducts.length === 0 ? (
            <p>No products found.</p>
          ) : (
            <div className="row">
              {filteredProducts.map((product) => (
                <div key={product.id} className="col-md-4 col-sm-6 mb-4">
                  <div className="card h-100 shadow-sm">
                    <img
                      src={product.image_url}
                      alt={product.name}
                      className="card-img-top"
                      style={{ height: "200px", objectFit: "cover" }}
                    />
                    <div className="card-body d-flex flex-column">
                      <h5 className="card-title">{product.name}</h5>
                      {/* <p className="card-text text-muted" style={{ fontSize: "0.9rem" }} dangerouslySetInnerHTML={{ __html: product.more_description?.substring(0, 60) }}></p> */}
                        
                
                      <p className="font-weight-bold text-success">₹{product.price}</p>
                      <Link to={`/product/${product.id}`} className="btn btn-primary mt-auto w-100">
                       View Product
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
